import React from 'react';
import { getText } from '@storebrand-digital/fms-translations';
import { CardHeadingGroup, CardNav } from '@storebrand-digital/pretzel';
import { isProduction } from '../../utils/env';
import styles from './Dashboard.module.css';

function MyOtherArchives() {
  return (
    <div className={styles.otherArchivesContainer}>
      <div className="grid-container">
        <CardNav
          orientation="vertical"
          icon="folder"
          className="grid-item lg_cols-6"
          aria-label={getText('otherArchive.postkasse.label')}
        >
          {(ref) => (
            <CardHeadingGroup
              ref={ref}
              as="a"
              href={getText('otherArchive.postkasse.href')}
              data-trackid={`link-otherArchive_postkasse|${getText(
                'otherArchive.postkasse.label'
              )}`}
              heading={getText('otherArchive.postkasse.label')}
              description={getText('otherArchive.postkasse.caption')}
            />
          )}
        </CardNav>
        <CardNav
          orientation="vertical"
          icon="signature"
          className="grid-item lg_cols-6"
          aria-label={getText('otherArchive.signature.label')}
        >
          {(ref) => (
            <CardHeadingGroup
              ref={ref}
              as="a"
              href={getText(
                isProduction()
                  ? 'otherArchive.signature.href-prod'
                  : 'otherArchive.signature.href'
              )}
              data-trackid={`link-bankdocument_signing|${getText(
                'otherArchive.signature.label'
              )}`}
              heading={getText('otherArchive.signature.label')}
              description={getText('otherArchive.signature.caption')}
            />
          )}
        </CardNav>
      </div>
    </div>
  );
}

export default MyOtherArchives;
